export enum NavigationDirection {
  Backwards,
  Forwards,
}
